// var pageLoaderEl = jQuery('#dm_page_loader')
// var _ = {}
// /**
//  * Gets or sets cookies
//  * @param name
//  * @param value (null to delete or undefined to get)
//  * @param options (domain, expire (in days))
//  * @return value or true
//  */
// _.cookie = function (name, value, options) {
//   if (typeof value === 'undefined') {
//     var n, v,
//       cookies = document.cookie.split(';')
//     for (var i = 0; i < cookies.length; i++) {
//       n = jQuery.trim(cookies[i].substr(0, cookies[i].indexOf('=')))
//       v = cookies[i].substr(cookies[i].indexOf('=') + 1)
//       if (n === name) {
//         return unescape(v)
//       }
//     }
//   }
//   else {
//     options = options || {}
//     if (!value) {
//       value = ''
//       options.expires = -365
//     }
//     else {
//       value = escape(value)
//     }
//     if (options.expires) {
//       var d = new Date()
//       d.setDate(d.getDate() + options.expires)
//       value += '; expires=' + d.toUTCString()
//     }
//     if (options.domain) {
//       value += '; domain=' + options.domain
//     }
//     if (options.path) {
//       value += '; path=' + options.path
//     }
//     document.cookie = name + '=' + value
//   }
// }
//
// var hasLoadedBefore = _.cookie('hasLoadedBefore')
// if (!!hasLoadedBefore) {
//   jQuery('#pageLoadStatus').text('Every Other time') // When this page has
//   // been loaded before.
//
// }
// else {
//   jQuery('#pageLoadStatus').text('First time.') // When this page loaded at
//   // first time.
//
// }
// _.cookie('hasLoadedBefore', true)



window.addEventListener('load', () => {
  if (document.getElementsByTagName('html')[0].classList.contains('html_loading')) {
    document.getElementsByTagName('html')[0].classList.remove('html_loading')
    document.querySelector('body').classList.add('dm-on-load-animate')
  }

  document.querySelector('#dm_page_loader').classList.add('hidden');
});
